export default __webpack_public_path__ + "static/media/d_lykozrout_smrkovy-min.67db14de.jpg";